/*! wscopy-notice.js — コピー禁止の確認チェック (2026-08-24 Winds Score)
 *
 *  アプリ Infinite Options で出していた「※本製品はコピー禁止です…」の
 *  チェックボックスを自作に置き換えたもの。出す/出さないの判定は
 *  snippets/ws-copy-notice.liquid (商品タグ + 顧客タグ) が行い、
 *  ここは **チェックが入るまでカート追加を止める** 役だけを持つ。
 *
 *  ボタンの disabled は他の自作スクリプトとも取り合いになる:
 *    data-wszep-disabled … 絶版           (wszeppan.js)
 *    data-wspre-locked   … 取り寄せ同梱   (ws-preorder-block-v2.js)
 *    data-wscopy-locked  … ここ
 *  ルール:
 *    - 掛けるときは自分の印を付けて disabled = true
 *    - 外すのは「自分の印があり、他の印が無く、初期状態が有効だった」ときだけ
 *      (売り切れ・絶版で最初から disabled のボタンを有効化してしまわないため)
 *    - 相手が外したら attribute 監視で掛け直す
 */
(function () {
  'use strict';

  var MSG = 'チェックボックスをご確認下さい。';   // Infinite Options と同じ文言
  var OTHER_LOCKS = ['data-wspre-locked', 'data-wszep-disabled'];

  function btnOf(box) {
    var form = box.closest ? box.closest('form[action*="/cart/add"]') : null;
    if (!form) return null;
    return form.querySelector('[name="add"], .add-to-cart, button[type="submit"]');
  }

  function lockedByOthers(el) {
    for (var i = 0; i < OTHER_LOCKS.length; i++) {
      if (el.hasAttribute(OTHER_LOCKS[i])) return true;
    }
    return false;
  }

  function lock(el, want) {
    // 初期状態(売り切れ・絶版など)は一度だけ覚える
    if (el.getAttribute('data-wscopy-init') === null) {
      el.setAttribute('data-wscopy-init', el.disabled ? '1' : '0');
    }
    if (el.getAttribute('data-wscopy-init') === '1') return;   // 元から買えないボタンには触らない

    if (want) {
      el.setAttribute('data-wscopy-locked', '');
      if (el.disabled !== true) el.disabled = true;            // 同値なら触らない(監視の再帰防止)
      el.setAttribute('aria-disabled', 'true');
      // disabled のボタンはクリックイベントを出さないので、理由を出せるよう
      // クリックを下の要素(フォーム)に通す
      if (el.style.pointerEvents !== 'none') el.style.pointerEvents = 'none';
    } else if (el.hasAttribute('data-wscopy-locked')) {
      el.removeAttribute('data-wscopy-locked');
      if (lockedByOthers(el)) return;                          // 他の理由で止まっているなら外さない
      if (el.disabled !== false) el.disabled = false;
      el.setAttribute('aria-disabled', 'false');
      if (el.style.pointerEvents === 'none') el.style.pointerEvents = '';
    }
  }

  /** 二重表示よけ。
   *  Infinite Options は他のオプションでも使い続けるので(2026-08-24 オーナー判断)、
   *  「アプリのオプションが出ているか」ではなく **同じ用途のチェックが出ているか**
   *  だけを見る。文言に「コピー禁止」を含むチェックボックスがアプリ側にある商品では
   *  自作を引っ込め、それ以外(納期などの別オプション)とは共存する。 */
  function appDuplicate() {
    var app = document.getElementById('infiniteoptions-container');
    if (!app) return false;
    var cbs = app.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < cbs.length; i++) {
      var label = cbs[i].closest ? cbs[i].closest('label') : null;
      var text = (cbs[i].value || '') + ' ' + (label ? (label.textContent || '') : '');
      if (text.indexOf('コピー禁止') !== -1) return true;
    }
    return false;
  }

  function sync(box) {
    var check = box.querySelector('[data-wscopy-check]');
    var prop  = box.querySelector('[data-wscopy-prop]');
    var btn   = btnOf(box);
    if (!check) return;

    if (appDuplicate()) {                   // アプリ側に同じチェックがある → 自作は出さない・止めない
      if (!box.hidden) box.hidden = true;
      if (prop && !prop.disabled) prop.disabled = true;
      if (btn) lock(btn, false);
      return;
    }
    if (box.hidden) box.hidden = false;

    var ok = !!check.checked;

    if (prop && prop.disabled === ok) prop.disabled = !ok;     // チェック時だけ送信する
    if (ok) {
      box.classList.remove('is-error');
      hideMsg(box);
    }
    if (btn) lock(btn, !ok);
  }

  function showMsg(box) {
    var msg = box.querySelector('[data-wscopy-msg]');
    box.classList.add('is-error');
    if (msg) {
      if (msg.textContent !== MSG) msg.textContent = MSG;
      if (msg.hidden) msg.hidden = false;
    }
  }

  function hideMsg(box) {
    var msg = box.querySelector('[data-wscopy-msg]');
    if (msg && !msg.hidden) msg.hidden = true;
  }

  function syncAll() {
    var boxes = document.querySelectorAll('[data-wscopy]');
    for (var i = 0; i < boxes.length; i++) sync(boxes[i]);
  }

  function init() {
    syncAll();

    // チェックの変化
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-wscopy]')) syncAll();
    }, true);

    // 止めている理由を出す。disabled のボタン自身はイベントを出さないので、
    // pointer-events:none で通ってきたクリックを**ボタンの位置**で拾う
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var form = t.closest('form[action*="/cart/add"]');
      if (!form) return;
      var box = form.querySelector('[data-wscopy]');
      if (!box || box.hidden) return;
      var check = box.querySelector('[data-wscopy-check]');
      if (!check || check.checked) return;
      var btn = btnOf(box);
      if (!btn) return;
      var hit = (t === btn) || btn.contains(t);
      if (!hit && e.clientX) {
        var r = btn.getBoundingClientRect();
        hit = e.clientX >= r.left && e.clientX <= r.right &&
              e.clientY >= r.top  && e.clientY <= r.bottom;
      }
      if (hit) showMsg(box);
    }, true);

    // テーマ/アプリが disabled を書き換えたら掛け直す
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(syncAll, 120);
      }).observe(document.body, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['disabled']
      });
    }

    // バリエーション切り替えでテーマがボタンを差し替えることがある
    document.addEventListener('variant:change', syncAll, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
